module.exports = __webpack_public_path__ + "static/img/2.f3d3c1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/2.png
// module id = hYgS
// module chunks = 0